<template>
  <v-dialog v-model="adhocCreateInvoiceOpen" width="1000" persistant>
    <v-card>
      <v-card-title>{{ isUpfrontCosts ? 'Upfront Charges Preview' : 'Ad hoc Invoice'}} - {{ currentAccount.id }} </v-card-title>
      
      <v-card-text>
        <v-row>

          <v-col cols="12" md="3">
            <p class="mb-1 text-caption">Customer Name</p>
            <p><b>{{currentAccount.first_name}} {{currentAccount.last_name}}</b></p>
            <p class="mb-1 text-caption">Email Address</p>
            <p><b>{{currentAccount.email_address}}</b></p>
          </v-col>

          <v-col cols="12" md="3">
            <p class="mb-1 text-caption">Business Name</p>
            <p><b>{{currentAccount.business_name}}</b></p>
            <p class="mb-1 text-caption">Mobile Number</p>
            <p><b>{{currentAccount.mobile_number}}</b></p>
          </v-col>

          <v-col cols="12" md="3">
            <p class="mb-1 text-caption">Billing Address</p>
            <p>
              <b>{{currentAccount.address_line_one | notEmpty}}</b><br>
              <template v-if="currentAccount.address_line_two!==null&&currentAccount.address_line_two!==''">
                <b>{{currentAccount.address_line_two | notEmpty}}</b><br>
              </template>
              <b>{{currentAccount.address_city | notEmpty}}</b><br>
              <b>{{currentAccount.address_post_code | notEmpty}}</b><br>
              <b>{{currentAccount.address_country | notEmpty}}</b><br>
            </p>
          </v-col>

          <v-col cols="12" md="3">
            <p class="mb-1 text-caption">Delivery Address <v-icon small class="ml-2" @click="deliveryAddressDialogOpen=true">edit</v-icon></p>
            
            <template v-if="deliverAddress.line_one==='-'">
              <p><b>No address set</b></p>
            </template>
            <template v-else>
              <p>
                <b>{{deliverAddress.line_one | notEmpty}}</b><br>
                <template v-if="deliverAddress.line_two!==null&&deliverAddress.line_two!==''">
                  <b>{{deliverAddress.line_two | notEmpty}}</b><br>
                </template>
                <b>{{deliverAddress.city | notEmpty}}</b><br>
                <b>{{deliverAddress.post_code | notEmpty}}</b><br>
                <b>{{deliverAddress.country | notEmpty}}</b><br>
              </p>
            </template>
          </v-col>

        </v-row>

        <v-divider></v-divider>

        <v-row>

          <v-col><b>Line Items</b></v-col>
          <template v-if="!isUpfrontCosts">
            <v-col class="text-right"><v-btn small color="secondary" @click="editItemsDialogOpen=true"><v-icon small class="mr-3">edit</v-icon> Edit Items</v-btn></v-col>
          </template>

        </v-row>

        <v-data-table :headers="headers" :items="getCurrentAdhoc.lineItems" :hide-default-footer="true">
          <template v-slot:item.name="{ item }"><span class="body--text">{{ item.name }} ({{ item.cat }})</span></template>
          <template v-slot:item.quantity="{ item }"><span class="body--text">{{ item.quantity }}</span></template>
          <template v-slot:item.price="{ item }"><span class="body--text">{{ item.price | price }}</span></template>
          <template v-slot:item.total="{ item }"><span class="body--text">{{ (item.quantity * item.price) | price }}</span></template>
        </v-data-table>

        <v-divider></v-divider>
        
        <v-row class="mt-5 mb-n5">

          <v-col>
            <p>Exc VAT <b class="ml-3">{{itemTotals.exVat | price}}</b></p>
          </v-col>

          <v-col class="text-center">
            <p>VAT <b class="ml-3">{{itemTotals.vat | price}}</b></p>
          </v-col>

          <v-col class="text-right">
            <p>Total <b class="ml-3">{{itemTotals.total | price}}</b></p>
          </v-col>

        </v-row>

        <template v-if="isUpfrontCosts">
          <p class="mt-2 text-center"><b>Upfront charges will be sent to the customer when moving to "For Approval"</b></p>
        </template>

      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>

        <v-btn color="secondary" small @click="sendPaymentLink" :disabled="saveDisabled || setCreateAdhocLoading" :loading="setCreateAdhocLoading">SEND CUSTOMER PAYMENT LINK</v-btn>
        <v-btn color="secondary" small @click="makePayment" :disabled="saveDisabled || setCreateAdhocLoading" :loading="setCreateAdhocLoading">MAKE PAYMENT </v-btn>

        <v-spacer></v-spacer>

        <v-btn v-if="saveDisabled" color="error" text small>Please select at least 1 Item</v-btn>
       
        <template v-if="showSendInvoice">
          <v-btn color="primary" small @click="submit" :disabled="saveDisabled || setCreateAdhocLoading" :loading="setCreateAdhocLoading">SEND INVOICE</v-btn>
        </template>

        <v-btn color="primary" small outlined @click="closeDialog">{{(isModemUpdate || isUpfrontCosts)?'CLOSE':'CANCEL'}}</v-btn>

      </v-card-actions>
    </v-card>

    <AdhocEditItemsDialog :saveType="'adhoc'" :dialogOpen="editItemsDialogOpen" @close-dialog="editItemsDialogOpen=false"/>
    <DeliveryAddressDialog :dialogOpen="deliveryAddressDialogOpen" @close-dialog="deliveryAddressDialogOpen=false"/>
    
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters,mapMutations } from 'vuex';
  import AdhocEditItemsDialog from './AdhocEditItemsDialog';
  import DeliveryAddressDialog from './DeliveryAddressDialog';
  export default {
    components: {AdhocEditItemsDialog,DeliveryAddressDialog},
    data() {
      return {
        editItemsDialogOpen: false,
        deliveryAddressDialogOpen: false,
        headers: [
          {text: "Description",sortable: false,value: "name"},
          {text: "Quantity",sortable: false,value: "quantity"},
          {text: "Unit Price",sortable: false,value: "price"},
          {text: "Subtotal",sortable: false,value: "total"},
        ],
        ledger_url: process.env.VUE_APP_LEDGER_LINK || `https://ledger-test-bonline.appspot.com/`,
      }
    },
    filters: {
      notEmpty: (val)=>{
        return (val === null || val === "" || val === undefined)?'-':val;
      },
      price: (price)=>{
        let type = typeof price;
        if(type==='number'){
          return `£${price.toFixed(2)}`;
        }else{
          return `£${parseFloat(price).toFixed(2)}`;
        }
      },
    },
    computed: {
      ...mapState("accounts", ["currentAccount"]),
      ...mapState('products',['currentProduct','currentVoipSite','setCreateAdhocLoading']),
      ...mapState('adhoc',['isUpfrontCosts','adhocCreateInvoiceOpen','isModemUpdate']),
      ...mapGetters('adhoc',['getCurrentAdhoc','getAdhocLineItems']),
      
      saveDisabled(){ return (this.getCurrentAdhoc.lineItems.length===0); },
      itemTotals(){
        let totals = {exVat:0,vat:0,total:0};
        let items = this.getCurrentAdhoc.lineItems;
        items.forEach(item => {
          totals.exVat += (parseFloat(item.price) * item.quantity);
        });
        totals.vat = totals.exVat * this.$vatAmount;
        totals.total = totals.vat + totals.exVat;
        return totals;
      },
      deliverAddress(){
        if(this.currentProduct.delivery_address!==undefined&&this.currentProduct.delivery_address!==null){
          return this.currentProduct.delivery_address;
        }else{
          return {line_one:'-',line_two:'-',city:'-',county:'-',post_code:'-',country:'-'};
        }
      },

      showSendInvoice() {
        if (this.isUpfrontCosts) {
          return false;
        }

        return !this.isModemUpdate;
      }
    },
    methods: {
      ...mapActions('adhoc',['createAdhocInvoice']),
      ...mapActions('accounts',['sendPaymentLinkEmail']),
      ...mapActions('alerts',['setAlert']),
      ...mapMutations('adhoc',['setIsUpfrontCosts', 'setCurrentAdhocInvoiceLineItems']),
      sortData(){
        return {
          lead_id: this.currentProduct.lead_id,
          account_id: this.currentAccount.id,
          delivery_address: this.currentProduct.delivery_address,
          line_items: this.getCurrentAdhoc.lineItems.map(e=>{ return {
            charge_credit_id: e.id,
            product: e.name,
            quantity: e.quantity,
            total: parseFloat(e.price)*e.quantity
          }; })
        }
      },
      deliveryRequired(){
        let items = this.getCurrentAdhoc.lineItems;
        let cats = ['hardware phones','headsets', 'router'];
        let ret = false;
        items.forEach(i => {
          if(cats.indexOf(i.cat.toLowerCase())!==-1){
            ret = true;
          }
        });
        return ret;
      },
      async submit(){
        let error = false;
        if(this.currentAccount.id===undefined){
          this.setAlert({type:'error',message: 'This customer does not have a billing account, please create one and try again'});
          error = true;
        }else if(this.deliveryRequired()){
          if(this.deliverAddress.line_one==='-'){
            this.setAlert({type:'error',message: 'Please set a delivery address'});
            error = true;
          }
        }
        if(!error){
          let data = this.sortData();
          try{
            await this.createAdhocInvoice({acc_id:data.account_id,data:data});
            this.closeDialog();
          }catch(err){}
        }
      },
      async sendPaymentLink(){
        if(confirm('Are you sure?')){
          try{
            await this.sendPaymentLinkEmail(this.currentAccount.reference);
          }catch(err){}
        }
      },
      async makePayment(){
        window.open(`${this.ledger_url}payments/${this.currentAccount.id}?email=${encodeURIComponent(this.currentAccount.email_address)}`, "_blank");
      },
      closeDialog(){
        if (this.isUpfrontCosts) {
          this.setCurrentAdhocInvoiceLineItems([]);
        }
        this.setIsUpfrontCosts(false);
        this.$emit('close-dialog');
      }
    },
  }
</script>

<style lang="scss" scoped></style>
